import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { DateTime } from "luxon";
import "./recruiters.css";
import DataTable from "../../components/DataTable/DataTable";

const AllNotApprovedRecruitersTable = ({
  allNotApprovedRecruiters,
  approveRecruiterHandler,
  revokeRecruiterHandler,
  isDataLoaded,
  setPaginationState,
  totalCount,
}) => {
  const [dataResult, setDataResult] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);

  const columns = [
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => approveRecruiterHandler(e, row.original)}
            style={{ marginRight: 8 }}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            onClick={(e) => revokeRecruiterHandler(e, row.original)}
            className={"revokeBtn"}
          >
            Revoke
          </Button>
        </div>
      ),
      size: 280,
      enableSorting: false,
      enableColumnFilter: false,
    },
    { accessorKey: "firstName", header: "First Name", size: 200, enableColumnFilter: false },
    { accessorKey: "lastName", header: "Last Name", size: 200, enableColumnFilter: false },
    { accessorKey: "email", header: "Email", size: 350, enableColumnFilter: false },
    { accessorKey: "role.roleName", header: "User role", size: 200, enableColumnFilter: false },
    { accessorKey: "organizationnameduringsignup", header: "Recruitment Organization", size: 200, enableColumnFilter: false },
    {
      accessorKey: "phoneNumber",
      header: "Phone Number",
      cell: ({ row }) => row.original.phoneNumber || "",
      size: 200,
      enableColumnFilter: false,
    },
    { accessorKey: "country", header: "Country", size: 200, enableColumnFilter: false },
    { accessorKey: "requestDate", header: "Request Date", size: 200, enableColumnFilter: false },
  ];

  // Handle page change
  const handlePageChange = (newPage, newPageSize) => {
    setPageNumber(newPage);
    if (newPageSize && newPageSize !== takeNumberOfResult) {
      setTakeNumberOfResult(newPageSize);
    }
    setPaginationState({
      page: newPage,
      pageSize: newPageSize || takeNumberOfResult,
    });
  }

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setTakeNumberOfResult(newPageSize);
    setPageNumber(1);
    setPaginationState({
      page: 1,
      pageSize: newPageSize,
    });
  };

  useEffect(() => {
    let arr = [];
    if (!allNotApprovedRecruiters || !Array.isArray(allNotApprovedRecruiters)) {
      arr = [];
    }
    else {
      arr = allNotApprovedRecruiters.map(recruiter => ({
        ...recruiter,
        country: recruiter?.profile?.locationCountry
          ? JSON.parse(recruiter.profile.locationCountry).name
          : "",
        requestDate: recruiter.createdAt
          ? DateTime.fromISO(recruiter.createdAt).toFormat("MM/dd/yyyy")
          : "N/A",
      }));
    }
    setDataResult(arr);
  }, [allNotApprovedRecruiters]);
  
  return (
    <>
      <DataTable
        data={dataResult}
        columns={columns}
        isLoading={!isDataLoaded}
        totalRecords={totalCount}
        currentPage={pageNumber}
        pageSize={takeNumberOfResult}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        enableFiltering={false}
        enablePagination={true}
        enableSorting={false}
        pageSizeOptions={[10, 20, 50, 100]}
        isServerSide={true}
        noDataText="No results found !"
      />
    </>
  );
};

export default AllNotApprovedRecruitersTable;
